import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateShowCreateKeywordsReviewDisplay } from "@features/modalSlice";
import { ColDef } from "ag-grid-community";
import KeywordInfoCellRenderer from "@cell-renderers/KeywordInfoCellRenderer";
import { Button } from "react-bootstrap";
import { ICreateReviewKeywords, TCommonRowObj } from "@ts/common-types";
import { reviewActionClickHandler } from "@ts/bulk-keywords-addition";
import { Drawer } from "antd";
import AgGridModalLayout from "@components/wrappers/layouts/AgGridModalLayout";
import { setSpinner } from "@ts/utils";
import UpdateBidInputCellRenderer from "@/components/cell-renderers/UpdateBidInputCellRenderer";

interface IAdminSettings {
    showCreateKeywordsReviewDisplay: boolean;
}

const CreateKeywordsReviewModal: React.FC<IAdminSettings> = ({
    showCreateKeywordsReviewDisplay
}) => {
    const [gridHeight, setGridHeight] = useState<number>();
    const dispatch = useDispatch();
    const closeCreateKeywordsReviewModal = () => {
        dispatch(updateShowCreateKeywordsReviewDisplay(false));
    };

    const createKeywordsReviewData = useSelector(
        (state: Record<string, Record<string, ICreateReviewKeywords[]>>) => state.createKeywordsReviewData.value
    );

    const createKeywordsData = useSelector(
        (state: Record<string, Record<string, TCommonRowObj[]>>) => state.createKeywordsData.value
    );

    const [columnDefs] = useState<ColDef[]>([
        {
            field: "keyword",
            headerName: "Keyword",
            minWidth: 400,
            maxWidth: 500,
            filter: "agTextColumnFilter",
            lockPinned: true,
            cellClass: "lock-pinned",
            cellStyle: {
                margin: "0"
            },
            cellRenderer: KeywordInfoCellRenderer,
            cellRendererParams: {
                hasPinnedColumnValue: true,
                pinnedColumnValue: "Total",
            },
        },
        {
            field: "existingBid",
            headerName: "Current Bid",
            minWidth: 50,
            maxWidth: 130,
        },
        {
            field: "newBid",
            headerName: "New Bid",
            minWidth: 50,
            maxWidth: 130,
            cellRenderer: UpdateBidInputCellRenderer,
            cellRendererParams: {
                origin: "review-action",
            },
        }
    ])

    return (
        <>

            <Drawer
                title="Review Action"
                placement="right"
                width={710}
                onClose={closeCreateKeywordsReviewModal}
                open={showCreateKeywordsReviewDisplay}
                zIndex={2000}
            >
                <div className="keywords-side-modal">
                    <div className="text-warning fs-6 my-1">
                        {createKeywordsReviewData.length} target
                        {createKeywordsReviewData.length > 1 ? 's' : ''} already exist
                        {createKeywordsReviewData.length > 1 ? '' : 's'}. Do you want to update
                        {createKeywordsReviewData.length > 1 ? ' their' : ' its'} bid?
                    </div>

                    <div className="ag-theme-alpine border my-2" style={{
                        // height: `${gridHeight-20}px`,
                        height: "73vh",
                        width: '100%'
                    }}>

                        <AgGridModalLayout
                            rowData={createKeywordsReviewData}
                            columnDefs={columnDefs}
                            setGridHeight={setGridHeight}
                        />
                    </div>
                    <Button
                        className="btn btn-success my-3 keyword-side-modal-btn"
                        id="keyword-submit-btn"
                        data-bs-name="Submit"
                        onClick={(event) => {
                            setSpinner("add", event, true)
                            reviewActionClickHandler(
                                createKeywordsReviewData,
                                createKeywordsData,
                                event
                            )
                        }}
                    >
                        Submit
                    </Button>
                </div>
            </Drawer>
        </>
    );
};

export default CreateKeywordsReviewModal;